export default __webpack_public_path__ + "static/media/captionDrag.0dcd63ca.gif";